import axios from 'axios';

let formEl = document.querySelector('.estate-feedback');

if(formEl) {
  formEl.onsubmit = (e) => {
    e.preventDefault();
    let formData = new FormData(formEl);
    formData.set('action', 'realty_feedback');
    
    axios({
      url: ajaxurl,
      method: 'post',
      data: formData
    }).then((response) => {
      if(response.data == 'success') alertify.success('Заявка успешно отправлена');
      else if(response.data == 'fail') alertify.success('Произошла ошибка на стороне почтового сервера');
      else alertify.error('Произошла непредвиденная ошибка');
    })
    .catch((error) => {
      console.log(error);
      alertify.error('Произошла непредвиденная ошибка');
    });
  };
}